
  import { Vue, Component, Prop } from "vue-property-decorator";

  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import GroupChips from "@/components/companyProjects/GroupChips.vue";
  import RouteNames from "@/entities/RouteNames";

  import { Team_Project } from "@/generated/graphql";
  import GroupChipData from "@/entities/GroupChipData";

  @Component({
    components: {
      CardBodyItem,
      GroupChips,
    },
  })
  export default class ProjectGroupsCardItem extends Vue {
    @Prop({ type: Array, required: true }) readonly teams!: Team_Project[];

    routeNames = RouteNames;

    get alignment(): string {
      return this.teams.length ? "items-baseline" : "items-center";
    }

    get groups(): GroupChipData[] {
      return this.teams.map(({ team }) => {
        return {
          id: team.id || "",
          name: team.name || "",
          contractorsCount: team.contractors.length,
        }
      })
    }
  }
